// Usage's registration (docs/features/usage-and-spend.md): the window `usage` (one per Mac), the Mac's ⋯ › Usage…,
// and the wire kind `usage` (get · budgets → summary · alert; the last summary and the alerts stay on the link).
import { registerWindow } from '../../core/windows.js'
import { registerHomeItem } from '../../core/home-items.js'
import { registerWire } from '../../core/wire.js'

registerWindow('usage', { module: () => import('./usage.js'), css: ['windows/usage/usage.css', 'windows/widgets/access.css'], key: (a, key) => 'usage-' + (key || 'mac'), title: () => 'Usage', place: ['home', 'trailing'] })
registerHomeItem({ id: 'usage', label: 'Usage…', symbol: 'lucide:chart-column', needs: 'paired', section: 'mac', order: 30 })
registerWire('usage', (link, payload, m) => {
  if (m?.what === 'summary' && m.summary) { link.usage = m.summary; link.usageHeard = Date.now() }
  if (m?.what === 'alert' && m.alert) link.usageAlerts = [...(link.usageAlerts || []).filter((a) => a.id !== m.alert.id), m.alert].slice(-20)
})
